import React, { SFC } from "react";
import { connect } from "react-redux";
import { Button, Box } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

interface Props {
	service: any,
	setService: React.Dispatch<React.SetStateAction<any>>,
	items: any
}

const useStyle = makeStyles((theme: Theme) => ({
    buttons: {
        width: "158px",
        height: "48px",
        marginBottom: 10,
        marginLeft: 10,
        lineHeight: "16px",
    },
    buttonContainer: {
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
        },
    }
}));

const ServiceType: SFC<Props> = ({service, setService, items}: Props) => {
    const classes = useStyle();

    const rendered = items.map(item => {
        if(item.type === service) {
            return  <Button key={item.type} onClick={setService.bind(null, item.type)} color="secondary" variant="contained" className={classes.buttons}>{item.label}</Button>;
        }
        return <Button key={item.type} onClick={setService.bind(null, item.type)}  variant="contained" className={classes.buttons}>{item.label}</Button>;
    });

    return (
        <Box className={classes.buttonContainer}>
            {rendered}
        </Box>

    );
};

export default connect()(ServiceType);
